import React, { Fragment } from 'react'
import styled from 'styled-components'

import MEDIA from 'styles/media'
import Responsive from 'components/Responsive'
import Head from 'components/Head'
import Footer from 'components/Sidebar/components/Footer'
import NavBar from './components/NavBar'
import Breadcrumbs from './components/Breadcrumbs'

const Content = styled.div`
  width: 1000px;
  margin: 0 auto 30px;

  ${MEDIA.mobile} {
    width: 100%;
    padding: 0 22px 50px;
  }
`

const DefaultLayout = ({ children }) => (
  <Fragment>
    <Head />
    <NavBar />
    <Content>
      <Responsive.desktop>
        <Breadcrumbs />
      </Responsive.desktop>
      {children}
    </Content>
    <Responsive.mobile>
      <Footer isSticky />
    </Responsive.mobile>
  </Fragment>
)

export default DefaultLayout



// WEBPACK FOOTER //
// ./src/layouts/DefaultLayout/index.js